var _path, _path2, _rect, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGenieMainLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5925 20.7399C26.3612 21.6345 23.9528 22.1863 21.4337 22.3293C20.9993 22.3539 20.5616 22.3664 20.1209 22.3664C19.6802 22.3664 19.2425 22.3539 18.8081 22.3293C16.2884 22.1863 13.8795 21.6343 11.6478 20.7393C6.96443 18.8611 3.06194 15.4723 0.556458 11.1832C4.46169 4.49787 11.7609 0 20.1209 0C28.4809 0 35.7801 4.49787 39.6853 11.1832C37.1796 15.4728 33.2765 18.8618 28.5925 20.7399Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6476 22.4803C11.108 22.2639 10.5788 22.0275 10.061 21.7719C8.37796 22.946 6.95519 24.4083 5.88385 26.0766C7.70484 28.9122 10.5412 31.1526 13.945 32.3944C15.567 32.9861 17.3179 33.351 19.1491 33.4455H21.0575C22.8883 33.351 26.1062 35.1472 21.4335 39.6799C24.8379 38.4383 32.5016 28.9125 34.3228 26.0766C33.2545 24.413 31.8368 22.9543 30.16 21.782C29.6481 22.0339 29.1252 22.2672 28.5922 22.4809C26.361 23.3755 23.9525 23.9273 21.4335 24.0703C20.9991 24.0949 20.5614 24.1074 20.1207 24.1074C19.68 24.1074 19.2423 24.0949 18.8079 24.0703C16.2882 23.9273 13.8792 23.3753 11.6476 22.4803Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.687,
    y: 8.32244,
    width: 18.9093,
    height: 6.68764,
    rx: 3.34382,
    fill: "#162550"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.3561,
    cy: 11.6292,
    rx: 1.23811,
    ry: 1.22607,
    fill: "#04FED1"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.1032,
    cy: 28.1252,
    rx: 1.23811,
    ry: 1.22607,
    fill: "#162550"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.1517,
    cy: 11.6292,
    rx: 1.23811,
    ry: 1.22607,
    fill: "#04FED1"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.1517,
    cy: 28.1252,
    rx: 1.23811,
    ry: 1.22607,
    fill: "#162550"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.0563,
    cy: 28.1252,
    rx: 1.23811,
    ry: 1.22607,
    fill: "#162550"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenieMainLogo);
export default __webpack_public_path__ + "static/media/genieMainLogo.ed3c47b32e26252d5aa1de4e7b986911.svg";
export { ForwardRef as ReactComponent };